import React, { useState, useEffect, useContext } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getProductosByCategoria } from '../../actions/home';
import { Link } from 'react-router-dom';
import { CartContext } from '../../contexts/CartContext';
import Swal from 'sweetalert2';
import { formatPrice } from '../../utils/formatPrice';

export const OtherCategories = () => {
  const { addToCart } = useContext(CartContext);

  const [productos, setProductos] = useState({
    oneSeccion: [],
    twoSeccion: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const categoria = {
    oneSeccion: { code: '100' },
    twoSeccion: { code: '101' },
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { productos: oneSeccionProducts } = await getProductosByCategoria(categoria.oneSeccion.code, 10, 1);
        const { productos: twoSeccionProducts } = await getProductosByCategoria(categoria.twoSeccion.code, 10, 1);

        setProductos({
          oneSeccion: oneSeccionProducts || [],
          twoSeccion: twoSeccionProducts || [],
        });

      } catch (error) {
        setError('Error al cargar los productos.');
        console.error('Error al cargar los productos:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [categoria.oneSeccion.code, categoria.twoSeccion.code]);

  if (loading) return null;
  if (error) return <div>Error: {error}</div>;

  const addCarrito = (producto) => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Se agregó al carrito de compras",
      showConfirmButton: false,
      timer: 2500,
      customClass: {
        container: 'custom-body'
      }
    });

    const productoCantidad = { ...producto, cantidad: 1 };
    console.log('agregar', productoCantidad);
    addToCart(productoCantidad);
  };

  const renderSection = (title, categoryProductos) => {
    const productosArray = Array.isArray(categoryProductos) ? categoryProductos.slice(-2) : [];
    return (
      <div className='width-other-categories'>
        <div className='txt-center mb-20 container-100'>
          <div className='txt-semibold font-family-montserrat font20 bg-8566FF br5 color_white pdbtn txt-section-categoria'>
            {title}
          </div>
        </div>
        <div className='flex-container container-item container-100'>
          {productosArray.map((c, index) => {
            return (
              <div key={c.id || index} className='trj-other-categories trj-othercategories'>
                <Link to={`/detalle-producto/${c.productoSku}`} className='container-othercategories'>
                  <img src={c.productoImgUrlPrincipal} alt={c.productoNombre} className='img-responsive img-other-categories img-othercategories' />
                </Link>
                <div className='padding-categories-item container-100 pad-othercategories'>
                  <div className='container-100 flex-container flex-column container-box-othercategories'>
                    <div className='div-nohidden'>
                      <div className='other-categories-marca mr-right-auto font-family-yrsa txt-lighter'>
                        {c.marcaDescripcion}
                      </div>
                      <div className='font-description-othercategories font-othercategories font-family-montserrat font400'>
                        {c.productoNombre}
                      </div>
                    </div>
                    <div className='mrg-topauto mr-b1em'>
                      <div className='flex-container container-othercategories-precio precio-more-sale font-family-montserrat font400 pd-precios baseline-items'>
                        <div className='precio-othercategories font400 '>
                          {/* {`S/. ${c.productoPrecio}`} */}
                          {formatPrice(c.productoPrecio)}
                        </div>
                        {c.productoPrecioAnterior && (
                          <div className='tachado flex-center precio-tachado-othercategories' style={{marginLeft: '15px'}}>
                            {/* {`S/. ${c.productoPrecioAnterior}`} */}
                            {formatPrice(c.productoPrecioAnterior)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='container-btn-othercategories div-nohidden'>
                    <div
                      className='font-family-montserrat btn-cart btn-cart-othercategories pointer font14'
                      onClick={() => addCarrito(c)}>
                      Añadir al carrito
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

        </div>
      </div>
    );
  };

  const renderImagenSection = (title, images) => {
    const imagesArray = Array.isArray(images) ? images.slice(0, 2) : [];
    return (
      <div className='width-other-categories'>
        <div className='txt-center mb-20 container-100'>
          <div className='txt-semibold font-family-montserrat font20 bg-8566FF br5 color_white pdbtn txt-section-categoria'>
            {title}
          </div>
        </div>
        <div className='flex-container container-item container-100'>
          {imagesArray.map((image, index) => (
            <div key={index} className='image-item container-100'>
              <img src={image} alt={`Image ${index}`} className='img-responsive' />
            </div>
          ))}
        </div>
      </div>
    );
  };

  const imageUrls = [
    "http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=PC-ARMADAS-SM.png&version_id=null",
    "http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=PC-ARMADAS-SM.png&version_id=null",
  ];

  return (
    <div className='contenedor-padre flex-container'>
      {renderSection('Computación', productos.oneSeccion)}
      {renderSection('Gaming', productos.twoSeccion)}
      {renderImagenSection('Pc Armadas', imageUrls)}
    </div>
  );
};